import React, { useState, useEffect } from "react";
import { Grid, GridCellProps, GridColumn as Column } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { LoadingPanel } from "../Loading";
import OrderActions from "../../Dashboard/Tabs/Orders/OrderActions";
import {
  Dialog,
  DialogActionsBar,
} from "@progress/kendo-react-dialogs";
import { BASE_URL } from "../../../redux/actions/dashboard/env.variables";
import axios from "axios";
import { Audit } from "../../../types/orders/audit";
import {Button} from "../ButtonGroup/styles";

interface Props {
  tableData: any[];
  tableConfig: any[];
  loading: boolean;
  detailComponent: (props: any) => JSX.Element;
  requestNewPage: (skip: number, take: number, sort?: any) => void;
  take: number;
  skip: number;
  total: number;
  sort: any;
  setSort: (sort: any) => void;
  selectedParentRow?:any,
  setSelectedParentRow?: (selectedParentRow: any) => void;
  featuresAllowed: string[];
}

export const columnHeader = (props: any, tooltipText?: string) => {
  return (
    <a className="k-link" data-cy={props.title} onClick={props.onClick}>
      <span title={tooltipText} style={{ whiteSpace: "normal" }}>
        {props.title}
      </span>
      {props.children}
    </a>
  );
};

export default (props: Props) => {
  const [data, setData] = useState(props.tableData);
  const [visibleDialog, setVisibleDialog] = React.useState<boolean>(false);
  const [audits, setAudits] = React.useState<Audit[]>([]);
  const [featuresAllowed, setFeaturesAllowed] = React.useState<string[]>(props.featuresAllowed);

  useEffect(() => {
    setData(props.tableData);
  }, [props.tableData]);

  const downloadJsonFile = (jsonDebugInfo: string) => {
    try {
      // Verifica que jsonDebugInfo es un string
      if (typeof jsonDebugInfo !== 'string') {
        console.error('jsonDebugInfo no es un string válido');
        alert('Error: el formato del JSON es inválido.');
        return;
      }

      // Crea un blob con los datos JSON
      const blob = new Blob([jsonDebugInfo], { type: 'application/json' });
      const url = URL.createObjectURL(blob);

      // Crea un enlace para descargar el archivo
      const a = document.createElement('a');
      a.href = url;
      a.download = 'data.json'; // Nombre del archivo a descargar
      document.body.appendChild(a);
      a.click();

      // Limpia el DOM
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // Libera la URL creada
      alert('Archivo JSON descargado');
    } catch (error) {
      console.error('Error al crear el archivo JSON:', error);
      alert('Error al crear el archivo JSON.');
    }
  };


  const handleChangePage = (event: any) => {
    const { take, skip } = event.page;
    props.requestNewPage(skip, take, Object.values(props.sort[0]).filter(x => x !== null).length > 0 ? props.sort : null);
  };

  const handleChangeSort = (event: any) => {
    const sort = event.sort;
    props.setSort(sort);
    props.requestNewPage(props.skip, props.take, sort);
  };

  const expandChange = (event: any) => {
    event.dataItem.expanded = event.value;
    const updatedData = JSON.parse(JSON.stringify(data));
    setData(updatedData);
    if(props.setSelectedParentRow)
    props.setSelectedParentRow(data);
  };

  const toggleDialog = () => {
    setVisibleDialog(!visibleDialog);
  };

  const orderActions = (gridCellProps: GridCellProps) => (
    <OrderActions
      {...gridCellProps}
      auditory = { auditoryEvent }
      requestNewPage={props.requestNewPage}
      featuresAllowed={featuresAllowed}
    />
  );

  //todo pasar esto a custom axios
  const auditoryEvent = (dataItem: any) => {
    const endpoint = BASE_URL + `/api/Orders/OrdersAudits?orderId=${dataItem.id}`
    const userStr = localStorage.getItem("user") as string || "";
    if (userStr.length < 1)
      throw new Error("Not Authorized");
    const user = JSON.parse(userStr);

    const config: any = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "content-type": "application/json",
        "Authorization": `Bearer ${user.token}`
      }
    };
    axios.get(endpoint, config)
      .then(res => {
        if (res.status !== 200) throw new Error(`Failed to get audits ${res.statusText}`);
        return res.data;
       })
      .then((auditsResponse: Audit[]) =>{
        setAudits(auditsResponse);
        toggleDialog();
      })
      .catch(err => {
        console.error(err)
      });
  };

  return (
    <div>
      {props.loading && <LoadingPanel />}
      <Tooltip openDelay={100} position="right" anchorElement="element">
        <Grid
          style={{ fontSize: "100%", zoom: "92%" }}
          data={data}
          detail={(detailProps: any) => props.detailComponent(detailProps)}
          expandField="expanded"
          onExpandChange={expandChange}
          resizable
          scrollable={'none'}
          pageable
          sortable={true}
          sort={props.sort}
          take={props.take}
          skip={props.skip}
          total={props.total}
          onPageChange={handleChangePage}
          onSortChange={handleChangeSort}
        >
          {props.tableConfig.map((column: any, key: number) => {
            if (column.custom) {
              return (
                <Column
                  key={key}
                  field={column.rowValue}
                  title={column.headTitle}
                  cell={(detailProps: any) => column.custom(detailProps)}
                  width={"500px"}
                  sortable={column.sortable}
                  headerCell={(props: any) =>
                    columnHeader(props, column.tooltipText)
                  }
                />
              );
            }
            return (
              <Column
                key={key}
                field={column.rowValue}
                title={column.headTitle}
                // width="200px"
                sortable={column.sortable}
                headerCell={(props: any) =>
                  columnHeader(props, column.tooltipText)
                }
              />
            );
          })}
          <Column cell={orderActions} width="auto" />
        </Grid>
      </Tooltip>
      {visibleDialog && (
          <Dialog minWidth={800} height={600} title={"Logs de la orden"} onClose={toggleDialog}>
            <div style={{ overflowY: 'auto', maxHeight: 'calc(100% - 60px)' }}>
              {audits.map((audit, i) => (
                  <div key={i} style={{ margin: "25px" }}>
                    <p style={{ fontSize: "12px", fontWeight: "bold" }}>
                      {audit.date} | {audit.auditMessage}
                      {audit.jsonDebugInfo && (
                          <Button
                              onClick={() => downloadJsonFile(audit.jsonDebugInfo)}
                              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                              style={{ fontSize: "12px", marginLeft: "5px", borderRadius: "8px", padding: "4px" }}
                          >
                            Descargar Json
                          </Button>
                      )}
                    </p>
                  </div>
              ))}
            </div>
            <DialogActionsBar>
              <button
                  type="button"
                  className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                  onClick={toggleDialog}
              >
                Cerrar
              </button>
            </DialogActionsBar>
          </Dialog>
      )}
    </div>

  );
};
